import { selectQuestion } from "features/qualityForm/qualityFormSlices/qualityFormCommons";
import { ReactNode } from "react";

import { useAppSelector } from "app/hooks";
import { BaseQuestionType } from "../BaseQuestionType";
import "./QuestionBody.less";
import QuestionOption from "./QuestionOption";
export default function QuestionBody({
    questionId,
    isQuestionEditable = false,
    children,
    hideScore = false,
    canReviewResults = false,
}: {
    questionId: string;
    isQuestionEditable?: boolean;
    children?: ReactNode;
    hideScore?: boolean;
    canReviewResults?: boolean;
}) {
    const questionType = useAppSelector(
        (state) => selectQuestion(state, questionId)?.type
    );

    return (
        <div className="QuestionBody">
            {questionType !== BaseQuestionType.ReadOnlyTextBlockQuestion && (
                <div className={"answer-options-container"}>
                    <QuestionOption
                        questionId={questionId}
                        disabled={!isQuestionEditable}
                        questionType={questionType}
                        hideScore={hideScore}
                        canReviewResults={canReviewResults}
                    />
                    {children}
                </div>
            )}
        </div>
    );
}
